<template>
    <el-scrollbar class="pages-home">
        <div class="index-bar">
<!--            <div class="bar-title">-->
<!--                {{ storeInfo._region2 }}-->
<!--            </div>-->
            <div class="bar-banner">
                <el-image src="/images/jianfu-bg.jpg"/>
            </div>
        </div>
        <div class="index-bar">
            <div class="bar-title">
                本店支持以下积分兑换
            </div>
            <ul class="bar-score-list">
                <li class="bar-score-items" v-for="score in scoreType" :key="score.mark"
                    @click="scoreActive=score.mark">
                    <div class="bar-score-title">
                        <el-image :src="score.image"/>
                        <div>{{ score.name }}</div>
                    </div>
                    <div :class="`bar-score-check ${scoreActive===score.mark?'bar-score-checked':''}`">
                        <el-icon>
                            <CircleCheck/>
                        </el-icon>
                    </div>
                </li>
            </ul>
        </div>
        <div class="index-bar">
            <div class="bar-title">
                兑换须知
            </div>
            <ol class="bar-jingle">
                <li>本服务为线下积分换购消费，仅限会员本人操作</li>
                <li>积分换购金额1元起</li>
                <li>积分换购不提供凭证</li>
                <li>积分换购以航空公司通知短信或航空公司官网查询为准</li>
                <li>换购完成后请及时核销，如需退货请联系人工客服</li>
            </ol>
            <div class="bar-footer">
                <div class="footer-btn">
                    <el-button type="warning" size="large" @click="callSer">联系客服</el-button>
                    <el-button color="#F10180" size="large" @click="toPay" :disabled="goToPay">去结账</el-button>
                </div>
                <div class="bar-copyright">
                    <span>服务热线：400-036-0195</span>
                    <span>服务时间：7:30-22:30</span>
                    <p>本服务由成都全积分网络科技有限公司提供技术支持</p>
                </div>
            </div>
        </div>
    </el-scrollbar>

</template>

<script setup>

import {scoreType} from "@/utils/constant";
import {computed, onMounted, ref} from "vue";
import router from "@/router";
import {_alert, _message, callSer} from "@/utils/func";
import {useRoute} from "vue-router";
import {useStore} from "vuex";
import axiosApi from "@/utils/axiosApi";

const scoreActive = ref("");
const route = useRoute();
const store = useStore();
const storeInfo = computed(() => {
    return store.state.storeInfo;
})
const userInfo = computed(() => {
    return store.state.userInfo;
})
const toPay = () => {
    if (!scoreActive.value) {
        return _message("error", "请选择积分兑换方式！")
    }
    //判断是否登录，且登录方式为当前选项
    let rout = {name: 'login', params: {type: scoreActive.value}};
    if (Object.keys(userInfo.value).length && scoreActive.value === userInfo.value.accountType) {
        rout.name = 'pay';
    } else {
        store.commit("removeUserInfo");
    }
    router.push(rout)
}
onMounted(() => {
    store.commit("getStoreInfo")
    store.commit("getUserInfo")
    if (route.query.mark) {
        //获取门店信息
        new axiosApi({
            encode: "site",
            method: "store/info",
            body: {
                mark: route.query.mark
            }
        }).send((res) => {
            if (res.message.code !== "000") {
                store.commit("removeStoreInfo")
                return _alert(res.message.content, "错误")
            }
            const data = res.data;
            if (!['scjf', 'fjjf'].some(i => data.nickname === i)) {
                store.commit("removeStoreInfo")
                return _alert("暂不支持的兑换门店！", "错误")
            }
            store.commit("getStoreInfo", data)
        })
    } else if (Object.keys(storeInfo.value).length < 1) {
        store.commit("removeStoreInfo")
        _alert("门店信息获取失败！", "提示")
    }
});

const goToPay = computed(() => {
    return scoreActive.value.length < 1 || Object.keys(storeInfo.value).length < 1
})
</script>
<style lang="less" scoped>
.pages-home {
  background: #aeaeae;
  height: 100vh;
  overflow: auto;

  .index-bar {
    background: #fff;
    box-sizing: border-box;
    padding: 15px;

    & + .index-bar {
      margin-top: 10px;
    }

    .bar-title {
      border-left: 5px solid #F10180;
      padding-left: 10px;
      margin-bottom: 15px;
    }

    .bar-banner {
      height: 220px;
      border-radius: 8px;
      overflow: hidden;

      .el-image {
        height: 100%;
        width: 100%;
      }
    }

    .bar-score-list {
      list-style: none;

      .bar-score-items {
        list-style: none;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px 0;
        border-top: 1px solid #EAEAEA;

        .bar-score-title {
          display: flex;
          align-items: center;

          .el-image {
            width: 35px;
            margin-right: 5px;
          }
        }

        .bar-score-check {
          .el-icon {
            font-size: 1.45rem;
            color: #EAEAEA;
          }

          &.bar-score-checked {
            .el-icon {
              color: #F10180;
            }
          }
        }
      }
    }

    .bar-jingle {
      list-style-position: inside;
      line-height: 1.75;
      font-size: 14px;
    }

    .bar-footer {
      text-align: center;
      margin-top: 15px;

      .el-button {
        width: 140px;
      }

      .bar-copyright {
        margin-top: 10px;
        line-height: 1.75;
        font-size: 14px;
        color: #aeaeae;

        span + span {
          padding-left: 10px;
        }
      }
    }
  }
}
</style>
